import {
  PASS_PROMO_DATE_FORMATS,
  PASS_PROMO_MONTH_LABEL_PATTERNS,
} from "../../constants/pass";
import { formatDateInEnglish } from "../../helpers/dateTimeHelper";
import { getI18nLanguageFromLocalStorage } from "../../helpers/localStorageHelper";

export const formatPromoMonthLabel = (date) => {
  if (!date) return "";

  const pattern = PASS_PROMO_MONTH_LABEL_PATTERNS[getI18nLanguageFromLocalStorage()];
  if (!pattern) {
    return formatDateInEnglish(date, PASS_PROMO_DATE_FORMATS.BADGE_MONTH);
  }

  const monthNumber = formatDateInEnglish(date, PASS_PROMO_DATE_FORMATS.MONTH_NUMBER);

  return pattern.replace("{{month}}", monthNumber);
};

export const formatPromoDayLabel = (date) =>
  formatDateInEnglish(date, PASS_PROMO_DATE_FORMATS.BADGE_DAY);

export const splitPromoHighlight = (text) => {
  if (!text) return [];

  return String(text)
    .replace(/\s*\|\|\s*/g, "\n")
    .split(/(\[\[[^[\]]*\]\])/)
    .filter((part) => part !== "")
    .map((part) =>
      part.startsWith("[[") && part.endsWith("]]")
        ? { highlighted: true, value: part.slice(2, -2) }
        : { highlighted: false, value: part },
    );
};
